module.exports = __webpack_public_path__ + "img/index_banner.ffacd040.png";